import { FC } from "react";

interface BurgerMenuIconSVGProps {
    className?: string;
}

const BurgerMenuIconSVG: FC<BurgerMenuIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="27"
            height="18"
            viewBox="0 0 27 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0 1H27" stroke="currentColor" />
            <path d="M0 9H27" stroke="currentColor" />
            <path d="M0 17H27" stroke="currentColor" />
        </svg>
    );
};

export default BurgerMenuIconSVG;
